import { render, staticRenderFns } from "./Administrador.vue?vue&type=template&id=6e154a4e"
import script from "./Administrador.vue?vue&type=script&lang=js"
export * from "./Administrador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e154a4e')) {
      api.createRecord('6e154a4e', component.options)
    } else {
      api.reload('6e154a4e', component.options)
    }
    module.hot.accept("./Administrador.vue?vue&type=template&id=6e154a4e", function () {
      api.rerender('6e154a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/otros-documentos/Administrador.vue"
export default component.exports